import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { Case, StatusEnum } from 'src/app/shared/models/cases/case';
import { CaseSession } from 'src/app/shared/models/hearings/caseSession';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { CaseSearchParams } from 'src/app/shared/models/cases/caseSearchParams';
import { FileSummaryModalComponent } from 'src/app/shared/file-summary-modal/file-summary-modal.component';
import { DashboardApiService } from 'src/app/core/services/api/dashboard-api.service';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { ClientSummaryModalComponent } from 'src/app/shared/client-summary-modal/client-summary-modal.component';
import { Client, ClientLite } from 'src/app/shared/models/clients/client';
import { ClientSearchParams } from 'src/app/shared/models/clients/clientSearchParams';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { CaseLite } from 'src/app/shared/models/cases/caseLite';
import { DashboardData } from 'src/app/shared/models/dashboardData';
import { HearingsApiService } from 'src/app/core/services/api/hearings-api.service';
import { CaseSessionSearchParams } from 'src/app/shared/models/hearings/caseSessionSearchParams';


@Component({
  selector: 'app-data-entry-dashboard',
  templateUrl: './data-entry-dashboard.component.html',
  styleUrls: ['./data-entry-dashboard.component.scss']
})
export class DataEntryDashboardComponent implements OnInit {

  public rejectedCasesCount = 0;
  public rejectedClientsCount = 0;
  public overdueHearingsCount = 0;
  public deadlinesCount = 0
  public overdueExpertCount = 0

  public pendingCases: CaseLite[] = [];
  public rejectedCases: CaseLite[] = [];
  public pendingClients: ClientLite[] = [];
  public rejectedClients: ClientLite[] = [];
  public overDueHearings: CaseSession[] = [];
  public deadlines: CaseSession[] = [];

  public rejectedCasesParams = new CaseSearchParams();
  public rejectedClientsParams = new ClientSearchParams();
  public overDueHearingsParams = new CaseSessionSearchParams();

  columnMode: ColumnMode;
  SelectionType = SelectionType;

  @ViewChild('fileSummaryModal') fileSummaryModal: FileSummaryModalComponent;
  @ViewChild('clientSummaryModal') clientSummaryModal: ClientSummaryModalComponent;
  @ViewChild('hearingsTable') hearingsTable: any;
  @ViewChild('deadlinesTable') deadlinesTable: any;


  constructor(
    private dashboardApi: DashboardApiService,
    private filesApi: FilesApiService,
    private clientApi: ClientsApiService,
    private spinner: NgxSpinnerService,
    private hearingsApi: HearingsApiService) {
    this.rejectedCasesParams.isApproved = false;
    this.rejectedClientsParams.isApproved = false;
  }

  ngOnInit() {
    this.initLoad();
  }

  initLoad() {
    this.spinner.show();
    const initLoad$ = forkJoin([this.dashboardApi.getDashboardData()])
    initLoad$.subscribe({
      next: value => {
        this.handleResults(value[0]);
      }, complete: () => {
        this.spinner.hide();
      }
    });
  }

  handleResults(r: DashboardData) {
    this.rejectedCasesCount = r.count.rejectedCases || 0;
    this.rejectedClientsCount = r.count.rejectedClients || 0;
    this.deadlinesCount = r.deadlines.count;
    this.overdueHearingsCount = r.count.court || 0;
    this.overdueExpertCount = r.count.expert || 0;
    this.rejectedCases = r.rejectedCases.results;
    this.deadlines = r.deadlines.results;
  }

  getpendingCases() {
    this.spinner.show();

    this.dashboardApi.getNewCases(new SearchParams()).subscribe(
      r => {
        this.pendingCases = this.pendingCases.concat(r.results);
        this.spinner.hide();
      }
    )
  }


  getRejectedCases() {
    this.spinner.show();
    this.filesApi.getFilesLite(this.rejectedCasesParams).subscribe(
      r => {
        this.rejectedCases = this.rejectedCases.concat(r.results);
        this.spinner.hide();
      }
    )
  }

  getpendingClients() {
    this.spinner.show();

    this.dashboardApi.getNewClients(new SearchParams()).subscribe(
      r => {
        this.pendingClients = this.pendingClients.concat(r.results);
        this.spinner.hide();
      }
    )
  }


  getRejectedClients() {
    this.spinner.show();
    this.clientApi.getClientLite(this.rejectedClientsParams).subscribe(
      r => {
        this.rejectedClients = this.rejectedClients.concat(r.results);
        this.spinner.hide();
      }
    )
  }

  getOverdueHearings() {
    this.spinner.show();
    this.dashboardApi.getOverdueHearings(this.overDueHearingsParams).subscribe(
      r => {
        this.overDueHearings = this.overDueHearings.concat(r.results);
        this.spinner.hide();
      }
    )
  }


  onSelectFileSummary({ selected }) {
    this.fileSummaryModal.open(selected[0]);
  }

  onSelectClientSummary({ selected }) {
    this.clientSummaryModal.open(selected[0]);
  }

  onPage() { }

  loadTabContent(e) {
    console.log(e);
    if (e.nextId === 'rejectedCases' && !this.rejectedCases.length) {
      this.getRejectedCases();
    } else if (e.nextId === 'rejectedClients' && !this.rejectedClients.length) {
      this.getRejectedClients();
    } else if (e.nextId === 'hearings' && !this.overDueHearings.length) {
      this.getOverdueHearings();
    }
  }

  toggleDeadlineExpandRow(row) {
    this.deadlinesTable.rowDetail.toggleExpandRow(row);
  }

  toggleHearingExpandRow(row) {
    this.hearingsTable.rowDetail.toggleExpandRow(row);
  }

  hearingTransactionColor(session: CaseSession) {
    let overdueDate = (new Date().getDate() - new Date(session.createdDate).getDate());
    return overdueDate <= 3 ? 'bg-success' : overdueDate <= 5 ? 'bg-warning' : 'bg-danger';
  }
}
